import Lang from "@/lang";
import { Filter } from "@/types/filters";

const allItems = [{ text: Lang.all, value: null }];

export interface DateRange {
  type?: "basic" | "preset";
  value?: {
    startTime?: string;
    endTime?: string;
    preset?: string;
  };
}

export interface PlanFilterParams {
  advertiser: string[] | null;
  agency: string[] | null;
  project: string[] | null;
  scenario: string[] | null;
  plan: string[] | null;
  businessGoalPropertyValue: string[] | null;
  isApproved: string[] | null;
  search: string | null;
  dateRange: DateRange;
  lastModified: DateRange;
  projectOwnedBy: Record<string, string>[] | null;
  businessGoalOwnedBy: Record<string, string>[] | null;
  planOwnedBy: Record<string, string>[] | null;
  scenarioOwnedBy: Record<string, string>[] | null;
  page?: number;
  page_size?: number;
}

export type PlanFilterState = {
  filterParams: PlanOutputFilterParams;
  selectedFilters: string[];
};

export interface PlanOutputFilterParams {
  businessGoalPropertyValue: string[];
  mediaType: string[];
  plan: string[] | null;
  scenario: string[] | null;
}

export const defaultSelectedFilters = ["advertiser", "businessGoalPropertyValue", "isApproved", "dateRange", "search"];

export const defaultVisibleColumns = [
  "name",
  "agency_name",
  "advertiser_name",
  "owned_by",
  "business_goal",
  "approved",
  "publish_date",
  "select",
];

export const defaultTableHeaders = [
  { text: "Project - Business Goal - Plan - Scenario", value: "name" },
  { text: "Agency", value: "agency_name" },
  { text: "Advertiser", value: "advertiser_name" },
  { text: "Owned By", value: "owned_by" },
  { text: "Business Goal", value: "business_goal" },
  { text: "Is Approved", value: "approved" },
  { text: "Publish Date", value: "publish_date" },
  { text: "Last Modified", value: "last_modified" },
  { text: "Select", value: "select" },
];

export const defaultTableExportHeaders: Record<string, string> = {
  name: "Project",
  business_goal: "Business Goal",
  plan: "Plan",
  scenario: "Scenario",
  agency_name: "Agency",
  advertiser_name: "Advertiser",
  owned_by: "Owned By",
  business_goal_description: "Business Goal Description",
  approved: "Is Approved",
  publish_date: "Publish Date",
  last_modified: "Last Modified",
};

export const ALL_OBJECT = { name: Lang.all, email: Lang.all };

export const defaultPlanFilterValues: PlanFilterParams = {
  advertiser: [Lang.all],
  agency: [Lang.all],
  project: [Lang.all],
  plan: [Lang.all],
  scenario: [Lang.all],
  businessGoalPropertyValue: [Lang.all],
  isApproved: [Lang.all],
  search: null,
  dateRange: { type: "preset", value: { preset: "allTime" } },
  lastModified: { type: "preset", value: { preset: "last12Months" } },
  projectOwnedBy: [ALL_OBJECT],
  businessGoalOwnedBy: [ALL_OBJECT],
  planOwnedBy: [ALL_OBJECT],
  scenarioOwnedBy: [ALL_OBJECT],
};

export const planListFilters: Array<Filter> = [
  {
    label: Lang.advertiser,
    filterName: "MultipleSelectFilter",
    filterKey: "advertiser",
    apiKey: "advertisers",
    value: null,
    items: allItems,
    searchBar: true,
  },
  {
    label: Lang.businessGoal,
    filterName: "MultipleSelectFilter",
    filterKey: "businessGoalPropertyValue",
    apiKey: "business_goal_property_values",
    value: null,
    isPageDetails: true,
    items: allItems,
    searchBar: true,
  },
  {
    label: Lang.approved,
    filterName: "SingleSelectFilter",
    filterKey: "isApproved",
    apiKey: "is_approved",
    value: Lang.all,
    isPageDetails: true,
    items: allItems,
    searchBar: true,
  },
  {
    label: Lang.publishDate,
    filterName: "DateRangeFilter",
    filterKey: "dateRange",
    apiKey: "dateRange",
    value: null,
    isPageDetails: true,
    default: "last12Months",
  },
  {
    label: Lang.lastModified,
    filterName: "DateRangeFilter",
    filterKey: "lastModified",
    apiKey: "lastModified",
    value: null,
    isPageDetails: true,
    default: "last12Months",
  },
  {
    label: Lang.agency,
    filterName: "MultipleSelectFilter",
    filterKey: "agency",
    apiKey: "agencies",
    value: null,
    items: allItems,
    searchBar: true,
  },
  {
    label: Lang.search,
    filterName: "InputFilter",
    filterKey: "search",
    apiKey: "search",
    value: null,
    items: allItems,
    searchBar: true,
  },
  {
    label: Lang.project,
    filterName: "MultipleSelectFilter",
    filterKey: "project",
    apiKey: "projects",
    value: null,
    items: allItems,
    searchBar: true,
  },
  {
    label: Lang.plan,
    filterName: "MultipleSelectFilter",
    filterKey: "plan",
    apiKey: "plans",
    value: null,
    items: allItems,
    searchBar: true,
  },
  {
    label: Lang.scenarios,
    filterName: "MultipleSelectFilter",
    filterKey: "scenario",
    apiKey: "scenarios",
    value: null,
    items: allItems,
    searchBar: true,
  },
  {
    label: Lang.projectOwners,
    filterName: "MultipleObjectSelectFilter",
    filterKey: "projectOwnedBy",
    apiKey: "project_owned_by",
    value: null,
    items: allItems,
    searchBar: true,
  },
  {
    label: Lang.businessGoalOwners,
    filterName: "MultipleObjectSelectFilter",
    filterKey: "businessGoalOwnedBy",
    apiKey: "business_goal_owned_by",
    value: null,
    items: allItems,
    searchBar: true,
  },
  {
    label: Lang.planOwners,
    filterName: "MultipleObjectSelectFilter",
    filterKey: "planOwnedBy",
    apiKey: "plan_owned_by",
    value: null,
    items: allItems,
    searchBar: true,
  },
  {
    label: Lang.scenarioOwners,
    filterName: "MultipleObjectSelectFilter",
    filterKey: "scenarioOwnedBy",
    apiKey: "scenario_owned_by",
    value: null,
    items: allItems,
    searchBar: true,
  },
];
